import {
  CheckResults,
  ClearRefinements,
  InternalSearchbox,
  ScopeMenu,
  TagRefinement,
  TypeRefinement,
} from "components/page-components/Internal-Search/search-components"
import {
  Configure,
  InstantSearch,
  createInfiniteHitsSessionStorageCache,
} from "react-instantsearch-dom"
import {
  CustomInfiniteHits,
  FocussedInfiniteHits,
} from "components/page-components/Internal-Search"
import React, { useEffect, useRef, useState, memo } from "react"

import algoliasearch from "algoliasearch/lite"
import { useInternalSearchState } from "components/page-components/Internal-Search/utils"

export const InternalSearchModal = memo(
  ({ search_modal_active, close_search_modal }) => {
    const [is_focussed, set_focussed] = useState(false)

    const algoliaClient = algoliasearch(
      process.env.GATSBY_ALGOLIA_APP_ID,
      process.env.GATSBY_ALGOLIA_APP_KEY,
      { _useRequestCache: true }
    )
    const all_types = [
      "author",
      "blog",
      "event",
      "help-article",
      "lexicon",
      "news",
      "notice",
      "page",
      "job_posting",
    ]

    const types_without_tags = [
      "notice",
      "author",
      "page",
      "help-article",
      "event",
      "job_posting",
    ]

    const { emptyState, searchState, setSearchState, onSearchStateChange } =
      useInternalSearchState({ all_types })

    useEffect(() => {
      if (sessionStorage.getItem("internal_search_session_storage")) {
        const { focussed, last_search_state } = JSON.parse(
          sessionStorage.getItem("internal_search_session_storage")
        )
        if (last_search_state) {
          setSearchState(last_search_state)
        }
        set_focussed(focussed)
      }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    // const is_fachzeitschriften =
    //   location?.pathname?.split("/")?.[1] === "fachzeitschriften"
    const main_search_ref = useRef(null)
    const sessionStorageCache = createInfiniteHitsSessionStorageCache()

    return (
      <div
        className={`modal internal-search-modal ${
          search_modal_active ? "is-active" : ""
        }`}
      >
        <div
          className="modal-background"
          aria-label="close search modal"
          id="search-modal-background"
          onClick={close_search_modal}
          onKeyUp={() => {}} // this is necessary to keep the linter quiet :(
          role="button"
          tabIndex="0"
        ></div>
        <div
          className="modal-content pt-6 no-scrollbar px-2"
          style={{
            height: "100vh",
            maxHeight: "100vh",
          }}
        >
          <InstantSearch
            indexName={process.env.GATSBY_IS_INTERNAL_SEARCH}
            searchClient={algoliaClient}
            searchState={searchState}
            onSearchStateChange={onSearchStateChange}
          >
            <Configure
              {...{
                // filters:
                //   !is_fachzeitschriften && emptyState
                //     ? "is_fachzeitschriften:false"
                //     : undefined,
                hitsPerPage: 40,
              }}
            />

            <button
              onClick={close_search_modal}
              className="modal-close is-large"
              aria-label="close"
              id="search-modal-close-button"
            ></button>
            <div
              className="level has-text-white p-3 is-mobile"
              ref={main_search_ref}
            >
              <ScopeMenu
                {...{
                  searchState,
                  setSearchState,
                  set_focussed,
                  attribute: "scope",
                  all_types,
                }}
              />

              <div className="level-right">
                <ClearRefinements
                  {...{
                    searchState,
                    setSearchState,
                    clearsQuery: true,
                    set_focussed,
                  }}
                />
              </div>
            </div>
            <div className="px-3">
              <InternalSearchbox />

              <div
                className="columns is-gapless is-mobile mt-3"
                style={{
                  maxHeight: is_focussed
                    ? !types_without_tags.includes(
                        searchState?.refinementList?.type?.[0]
                      )
                      ? 5000
                      : 0
                    : null,
                  transition: "all .3s ease",
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    transition: `all .3s ease`,
                    transform: is_focussed
                      ? "translateX(-30%)"
                      : "translateX(0%)",
                    opacity: is_focussed ? "0" : "1",
                    visibility: is_focussed ? "hidden" : "visible",
                  }}
                  className="column is-12"
                >
                  <TypeRefinement
                    {...{
                      searchState,
                      setSearchState,
                      set_focussed,
                      search_modal_active,
                      attribute: "type",
                      all_types,
                      defaultRefinement: all_types,
                    }}
                  />
                </div>

                <div
                  style={{
                    transition: `all .3s ease`,
                    transform: is_focussed
                      ? "translateX(-100%)"
                      : "translateX(-70%)",
                    opacity: !is_focussed ? "0" : "1",
                    visibility: !is_focussed ? "hidden" : "visible",
                  }}
                  className="column is-12"
                >
                  {is_focussed ? (
                    <TagRefinement
                      {...{
                        attribute: "tags",
                        showMoreIncrements: 7,
                        limit: 999,
                        searchState,
                      }}
                    />
                  ) : null}
                </div>
              </div>
            </div>
            <CheckResults {...{ searchState, setSearchState, set_focussed }}>
              <div className="" style={{ overflowX: "hidden" }}>
                <div
                  className=""
                  style={{
                    transition: `all .3s ease`,
                    transform: is_focussed
                      ? "translateX(-30%)"
                      : "translateX(0%)",
                    opacity: is_focussed ? "0" : "1",
                    visibility: is_focussed ? "hidden" : "visible",
                  }}
                >
                  {!is_focussed ? (
                    <CustomInfiniteHits
                      {...{
                        close_search_modal,
                        emptyState,
                        cache: sessionStorageCache,
                        searchState,
                        setSearchState,
                        set_focussed,
                      }}
                    />
                  ) : null}
                </div>
                <div
                  style={{
                    transition: `all .3s ease`,
                    transform: !is_focussed
                      ? "translateX(30%)"
                      : "translateX(0%)",
                    opacity: !is_focussed ? "0" : "1",
                    visibility: !is_focussed ? "hidden" : "visible",
                  }}
                >
                  {is_focussed ? (
                    <FocussedInfiniteHits
                      {...{
                        all_types,
                        cache: sessionStorageCache,
                        close_search_modal,
                        is_focussed,
                        main_search_ref,
                        searchState,
                        setSearchState,
                        set_focussed,
                        types_without_tags,
                      }}
                    />
                  ) : null}
                </div>
              </div>
            </CheckResults>
          </InstantSearch>
        </div>
      </div>
    )
  }
)
